import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ViewController } from 'ionic-angular';
import { Http } from '@angular/http';
import { Storage } from '@ionic/storage'
import { Base64 } from 'js-base64';
/**
 * Generated class for the ImpresoraBluePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-impresora-blue',
  templateUrl: 'impresora-blue.html',
  providers: []
})
export class ImpresoraBluePage {
  imprimir:any
  token:string
  constructor(public navCtrl: NavController, public navParams: NavParams,public http: Http,
    private storage:Storage,public viewControllers:ViewController) {
    this.storage.get('token').then((val) => {
      this.token = val
  }
  );

    this.imprimir = this.navParams.get('item')
  }


  ionViewDidLoad() {


  }



  descargarArchivo(data:any){
    let datanew = JSON.parse(this.imprimir.nombre)
    let recibo = ''

    for (let index:any = 0; index < datanew[0].length; index++) {
      recibo +=  '   ' + datanew[0][index]['reciboCaja'] + '\n'
    }

    let encodedString = Base64.encode(recibo);
    window.open(`sartprintbluetooth://print/${encodedString}`, '_self');

     this.viewControllers.dismiss(recibo);


}

}



// WEBPACK FOOTER //
// ./src/pages/impresora-blue/impresora-blue.ts